
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContractComparePage from "../pages/contract-compare/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ContractComparePage />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
